import {
  DEFAULT_PROJECT_PROPERTY_TYPE,
  ProjectPropertyType,
} from 'src/constants/project';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setAllPropertyTypes =
  (propertyType: ProjectPropertyType = DEFAULT_PROJECT_PROPERTY_TYPE) =>
  (model: Model) => {
    const propertyTypesByIri: Record<string, ProjectPropertyType> = {};
    Object.keys(model.modelData.propertyTypesByIri).forEach((key) => {
      propertyTypesByIri[key] = propertyType;
    });
    setDataProperty<ModelData>(model)(
      model.modelData,
      'propertyTypesByIri',
      propertyTypesByIri
    );
  };
